<template>
	<v-data-table
		dense
	    fixed-header
	    :headers 			 = "headers"
	 	:items 	 			 = "list_render"
	    class 	 			 = "elevation-5"			    
	    :hide-default-footer = "height < 56 ?  true : false"
	   	:options.sync 		 = "options"
	   	:server-items-length = "total"
	   	loading-text 		 = "Loading... Please wait"
	    :height 			 = "height + 'px'"
	    item-key 			 = "index"
	    :loading 			 = "loading"
	   	:footer-props 		 = "{
	   		showFirstLastPage   : true,
	   		itemsPerPageOptions : [15, 30],
	   		showCurrentPage     : true
	   	}"
	>
		<template v-slot:top >
			<v-row
				v-show = "false"
			>
				
				<template
					v-for = "(item_search, idx_search) of search_options"
				>
					<v-col
						cols = "3"
					>
						
						<v-text-field
							dense
							outlined
							hide-details
							:label  = "$ml.get(item_search.text)"
							v-if 	= "item_search.type == 'text'"
							:type  	= "item_search.type"
							v-model = "info_search[item_search.key]"
						></v-text-field>
						<searcher
							v-else-if		   = "item_search.type == 'select_searcher'"
							:info_to_component = "item_search"
							:info_to_list  	   = "render_listed(item_search.list)"
							@receive_info	   = "info_search[item_search.key] = $event"
						></searcher>
					</v-col>
				</template>
				<v-col
					cols = "2"
				>
					<v-btn
						color  = "primary"
						v-text = "$ml.get('search')"	
						@click = "get_search()"
					></v-btn>
				</v-col>
			</v-row>
		</template>
	</v-data-table>
</template>
<script>
	import searcher from "@/components/info/searcher.vue"

	export default{
		name 		: "technical",
		components  : {
			searcher,
		}, // searcher
		data : (vm) => ({
			info_search : {},
			headers : [
				{ text : vm.$ml.get("code"), value : "code" },
				{ text : vm.$ml.get("module"), value : "module" },
				{ text : vm.$ml.get("device"), value : "deviceId" },
				{ text : vm.$ml.get("detail"), value : "detail" },
				{ text : vm.$ml.get("type"), value : "type" },
				{ text : vm.$ml.get("state"), value : "state" },
				{ text : vm.$ml.get("date"), value : "date" },				

			],
			height 	: 400, 
			options : { itemsPerPage : 30 },
			total   : 0,
			loading : false,
			list 	: [],
			search_options : [
				/*{
					key : 'code',
					text : 'code',
					type : 'text',
				},
				{
					key : 'module',
					text : 'module',
					type : 'text',
				},*/
				{
					key : 'deviceId',
					text : 'search',					
					placeholder : 'device',								
					list 		: 'list_devices',
					key_list	: 'deviceId',
					text_list 	: 'name',
					type 		: 'select_searcher',
					key_search  : 'name',
					key_search_1 : 'deviceId',
					visible 	: true,
				},
			],
			list_devices : [],
		}), // data

		watch : {
			options : {
				handler(){
					if (this.info_search && (this.info_search.code || this.info_search.module || this.info_search.deviceId)) {						
						this.get_search();
							
					}else{
						this.get_list();
					}
					
				}, deep : true,
			}, // options
		}, // watch

		created(){
			this.$Format.update_list(this.$ml, 'ml');

			let temp_devices = this.$Helper.get_local('list_devices');
			if (temp_devices) {
				this.list_devices = temp_devices;
			}

		}, // created

		computed : {
			list_render : function(){
				return this.list;
			}
		}, // computed
		methods : {
			get_list(){
				this.list 		= [];
				this.loading 	= true;
				const  { page, itemsPerPage } = this.options;
				let pg = 1, sw 	= 0;
				if (itemsPerPage == 15) {
					if (page % 2 == 0) {
						pg 	= (page/2);
						sw 	= 2;
					}else{
						pg  = parseInt(page/2)+1;
						sw 	= 1;
					}
				}else{
					pg 		= page
				}
				const api = this.$URL + "/api/v1/technical_records" + "/?page=" + pg;

				this.$axios.get(api).then( res => {
					console.log("res technical : ", res);
					if (res && res.data){
						let items  = [];
						
						items 	   = this.render_format(res.data.rows);						
						this.total = res.data.count;
						if (items) {
							this.list  = items;
						}
					}
					this.loading = false;
				}).catch( er => {
					console.log("Error get technical : ", er);
					this.loading = false;
				})
				
			}, // get list



			render_format(items){
				let list_temp = [...items];
				if (list_temp && list_temp.length > 0) {
					list_temp.forEach((dev)=>{

						dev.device = this.$ml.get('data_no_found');
						if (dev.deviceId) {
							let temp_dev = this.$Format.render_device(dev.deviceId);
							if (temp_dev) {
								dev.device = temp_dev.name; 
							}
						}
						if (dev.createdAt) {
							let temp_date	= this.$Format.format_date(dev.createdAt, "createdAt");
							if (temp_date) {
								dev.date = temp_date;
							}
						}
					});
					return list_temp;
				}
				return false;
			}, // render format
			render_listed(item){
				if (item && this[item]) {
					return this[item]
				}
			}, // render listed

			get_search(){
				const  { page, itemsPerPage } = this.options;
				let pg = 1, sw 	= 0;

				if (itemsPerPage == 15) {
					if (page % 2 == 0) {
						pg 	= (page/2);
						sw 	= 2;
					}else{
						pg  = parseInt(page/2)+1;
						sw 	= 1;
					}
				}else{
					pg 		= page
				}
				const api 	 = this.$URL + "/api/v1/technical_records/find" + "/?page=" + pg;
				this.loading = true;
				let info_up  = this.info_search;
				this.$axios.post(api, info_up).then( res => {
					console.log("res technical search : ", res);
					if (res && res.data){
						let items  = this.render_format(res.data.rows);
						this.total = res.data.count;
						if (items) {
							this.list  = items;
						}
					}
					this.loading = false;
				}).catch( er => {
					console.log("Error get technical search: ", er);
					this.loading = false;
				});
			
			}, // get search
		}, // methods
	}; 
</script>